// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8c1a04a4f0463956f3cc","655":"4b41bd9913c44ba70119"}[chunkId] + ".js";
};